const STYLES = {
  confirmed: "bg-emerald-50 text-emerald-800 border-emerald-200",
  pending_payment: "bg-amber-50 text-amber-800 border-amber-200",
  cancelled: "bg-hbe-soft text-hbe-accent border-hbe-line",
  active: "bg-emerald-50 text-emerald-800 border-emerald-200",
  inactive: "bg-hbe-soft text-hbe-accent border-hbe-line",
  archived: "bg-red-50 text-red-800 border-red-200",
  paid: "bg-emerald-50 text-emerald-800 border-emerald-200",
  deposit_paid: "bg-emerald-50 text-emerald-800 border-emerald-200",
  pending: "bg-amber-50 text-amber-800 border-amber-200",
  failed: "bg-red-50 text-red-800 border-red-200",
  refunded: "bg-hbe-soft text-hbe-accent border-hbe-line",
  refund_needed: "bg-red-50 text-red-800 border-red-200",
  manual: "bg-hbe-soft text-hbe-primary border-hbe-line",
  fully_paid: "bg-emerald-100 text-emerald-900 border-emerald-300",
  balance_overdue: "bg-red-100 text-red-900 border-red-300",
  deposit_only: "bg-amber-50 text-amber-800 border-amber-200",
};

const LABELS = {
  confirmed: "Confirmed",
  pending_payment: "Pending payment",
  cancelled: "Cancelled",
  active: "Active",
  inactive: "Inactive",
  archived: "Archived",
  paid: "Paid",
  deposit_paid: "Deposit paid",
  pending: "Pending",
  failed: "Failed",
  refunded: "Refunded",
  refund_needed: "Refund needed",
  manual: "Manual",
  fully_paid: "Fully paid",
  balance_overdue: "Balance overdue",
  deposit_only: "Deposit only",
};

export default function StatusBadge({ status }) {
  const cls = STYLES[status] || "bg-hbe-soft text-hbe-accent border-hbe-line";
  const label = LABELS[status] || String(status || "—");
  return (
    <span
      className={`inline-flex items-center px-2.5 py-1 rounded-full text-[11px] font-medium tracking-wide border ${cls}`}
      data-testid={`status-badge-${status}`}
    >
      {label}
    </span>
  );
}
